import ProjectsSearch from "./Components/Projects";
import UsersSearch from "./Components/Users";

const Segmentation = ({ configs }) => {
  const { projectsConfig, usersConfig } = configs;

  const {
    useProjects = true,
    projects,
    selectedProjects,
    setSelectedProjects,
    getProjects,
    setProjects,
  } = projectsConfig;

  const {
    useUsers = true,
    users,
    selectedUsers,
    setSelectedUsers,
    getUsers,
    setUsers,
  } = usersConfig;

  return (
    <>
      {useProjects && (
        <ProjectsSearch
          projects={projects}
          selectedProjects={selectedProjects}
          setSelectedProjects={setSelectedProjects}
          getProjects={getProjects}
          setProjects={setProjects}
        />
      )}
      {useUsers && (
        <UsersSearch
          users={users}
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          getUsers={getUsers}
          setUsers={setUsers}
        />
      )}
    </>
  );
};

export default Segmentation;
